import {ChecklistTemplateKind, useChecklistTemplates} from '@domain/hroc-checklists'
import {DataContentWrapper} from '@hconnect/common/containers'
import {type TimeZone} from '@hconnect/common/types'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import {ChecklistTemplatesList, type ChecklistTemplate} from '@widgets/hroc-checklists'

type Props = {
  plantId: string
  selectedTemplateId?: string
  onTemplateClick: (template: ChecklistTemplate) => void
  timezone: TimeZone
}

export const ChecklistTemplatesListContainer: React.FC<Props> = ({
  plantId,
  selectedTemplateId,
  onTemplateClick,
  timezone
}) => {
  const isKilnCheckSheetEnabled = useCommonFeatureFlag(FeatureFlagKey.ChecklistsKilnCheckSheet, {
    plantId
  })

  const templateKinds = isKilnCheckSheetEnabled ? undefined : [ChecklistTemplateKind.TakeFive]

  const {data, isLoading, isRefetching, isError, refetch} = useChecklistTemplates({
    plantId,
    templateKinds
  })

  return (
    <DataContentWrapper
      showLoader={isLoading}
      isError={isError}
      data={data}
      retryFunction={() => void refetch()}
      isRefetching={isRefetching}
    >
      <ChecklistTemplatesList
        data={data}
        selectedTemplateId={selectedTemplateId}
        onTemplateClick={onTemplateClick}
        timezone={timezone}
      />
    </DataContentWrapper>
  )
}
